export default __webpack_public_path__ + "static/media/about_us_tim.3de49cbb.png";